<template>
  <div class="login_Register">
    <div class="wrap">
      <!--header start-->
      <div class="header login-header">
        <a href="javascript:void(0);" @click="fn" class="icon-back"></a>注册账号
      </div>
      <div class="line-gray"></div>
      <!--header end-->

      <!--content start-->
      <div class="content login-content">
        <div class="lg-tab">
          <span class="lg-active"><i class="icon-phone"></i>手机</span>
          <span><i class="icon-email"></i>邮箱</span>
        </div>
        <form class="lg-tabbox">
          <div class="group-item">
            <label>手机</label>
            <div class="input-box input-tel">
              <input type="tel" placeholder="请输入常用手机号" class="in" id="phone" maxlength="11" v-model="phone"/>
              <div class="btn-del" style="display: none" v-show="phone != ''" @click="phone = ''">
              </div>
            </div>

          </div>
          <p class="text-danger" style="display:none" id="phone-mess"></p>

          <div class="group-item">
            <label>验证码</label>
            <div class="input-box input-yzm">
              <input type="tel" placeholder="请输入验证码" id="yzm"/>
              <a href="javascript:void(0);" class="btn-yzm puts">发送验证码</a>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="yzm-mess"></p>
          <div class="group-item">
            <label>密码</label>
            <div class="input-box">
              <input type="password" id="pass" placeholder="6-20位任意字符区分大小写"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="pass-mess"></p>

          <div class="group-item">
            <label>确认密码</label>
            <div class="input-box">
              <input type="password" id="repass" placeholder=""/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="repass-mess"></p>
          <div class="group-item">
            <label>图形验证</label>
            <div class="input-box input-picyz">
              <input type="text" placeholder="" id="yzm-data"/>
              <img class="picyz" src="http://reg.cctv.com/simple/verificationCode.action"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="yzm-img"></p>
          <div class="group-terms">
            <div class="check-box">
              <input type="checkbox">
            </div>
            <p class="terms">
              阅读并同意<a id="cctvmess" href="javascript:void(0);">《央视网网络服务使用协议》</a>
            </p>
          </div>
          <p class="text-danger" style="display:none" id="xieyi-mess"></p>
          <div class="group-info">
            <a href="javascript:void(0);" id="logined" class="font-lgr">注&nbsp;&nbsp;册</a>
          </div>
        </form>
        <form class="lg-tabbox" style="display:none">
          <div class="group-item">
            <label>邮箱</label>
            <div class="input-box input-tel">
              <input type="email" id="email" placeholder="请使用常用邮箱" class=""/>
              <div class="btn-del" style="display: none">
              </div>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="email-mess"></p>
          <div class="group-item">
            <label>密码</label>
            <div class="input-box">
              <input type="password" id="pass_email" placeholder="6-20位任意字符区分大小写"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="pass-mess-email"></p>

          <div class="group-item">
            <label>确认密码</label>
            <div class="input-box">
              <input type="password" id="repass_email" placeholder=""/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="repass-mess-email"></p>
          <div class="group-item">
            <label>图形验证</label>
            <div class="input-box input-picyz">
              <input type="text" placeholder="" id="yzm_email"/>
              <img class="picyz" src="https://reg.cctv.com/simple/verificationCode.action"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="yzm-img-email"></p>
          <div class="group-terms group-terms-email">
            <div class="check-box">
              <input type="checkbox">
            </div>
            <p class="terms">
              阅读并同意<a href="javascript:void(0);">《央视网网络服务使用协议》</a>
            </p>
          </div>
          <p class="text-danger" style="display:none" id="xieyi-mess-email"></p>
          <div class="group-info">
            <a href="javascript:void(0);" id="loginede" class="font-lgr">注&nbsp;&nbsp;册</a>
          </div>
        </form>
      </div>
      <!--content end-->

    </div>


    <!-- Modal -->

    <!-- protocol -->
    <div class="modal-confim large-info-modal modal fade" id="modalConfim" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document" style="margin-top: 80px">
        <div class="modal-content" style="top: 0;overflow-y: auto;height: 500px;">
          <div class="protocol-bg">
            <div class="protocol" style="padding: 20px">
              <div class="pro-close"></div>
              <h5>央视网网络服务使用协议</h5>
              <div class="protocol-txt">
                <p>第一章 服务使用协议的确认和接纳</p>
                <p>第一条
                  央视网网络服务使用协议（以下简称“协议”）是由用户（您）与央视国际网络有限公司（央视网）就央视网提供的网络服务所订立的相关权利义务规范，本协议对您及央视网均具有法律效力，未成年人需在法定监护人的陪同下审阅。</p>
                <p>第二条 央视网（网址：www.cctv.com、
                  www.cntv.cn）完全按照其发布的服务条款和操作规则向用户提供服务。本协议所称的用户（您）是指完全同意所有协议条款并完成注册程序或未经注册而使用央视网提供各项服务的个人或机构。</p>
                <p>第三条 您同意接受本协议，方可注册成为央视网正式用户。您注册成功后，央视网将给予您一个帐号及相应的密码，该帐号和密码由您负责保管；您对以该帐号进行的所有活动和事件负法律责任。</p>
                <p>第四条 您注册前，请认真阅读本协议。注册成功后，即视为同意接受本协议的全部内容，受本协议的约束。</p>
                <p>第二章 服务使用协议的变更和修改</p>
                <p>第五条 本协议的订立、执行、解释及争议的解决均应遵守中华人民共和国有关法律、法规，如协议之任何一部分与中华人民共和国法律、法规相抵触，则该部分条款应按法律规定执行。</p>
                <p>第六条 央视网有权随时修改本协议的任何条款，并在央视网上公示，而无需另行单独通知您，您可随时通过央视网浏览最新服务使用协议条款。</p>
                <p>第七条 当您使用央视网的特殊服务时，应接受央视网随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本协议的一部分。</p>
                <p>第八条 如果不同意央视网对本协议相关条款所做的修改，您可以主动向客服要求取消已经获得的网络服务；如果您继续使用网络服务，则视为您接受央视网对本协议相关条款所做的修改。</p>
                <p>第三章 服务说明</p>
                <p>第九条
                  央视网网络服务的具体内容由央视网根据实际情况提供，包括论坛（BBS）、博客、微博、播客、跟帖评论、边看边聊、邮箱、搜索等。除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品，均无条件地适用本协议。</p>
                <p>第十条
                  您接受本协议，须同意并提供完整、真实、准确、最新的身份信息，并不断更新注册资料。若您提供任何错误、不实、过时或不完整的身份信息，并为央视网所确知；或者央视网有合理理由怀疑前述信息为错误、不实、过时或不完整，央视网有权暂停或终止您的帐号权限，并拒绝现在或将来向您提供本服务的全部或一部分。</p>
                <p>第十一条
                  您理解：央视网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由您自行负担。</p>
                <p>第四章 您应遵守以下法律及法规</p>
                <p>第十二条 您承诺遵守中华人民共和国有关法律法规和规范性文件，承担一切因您的行为直接或间接引起的法律责任。</p>
                <p>第十三条 您也应了解国际互联网的无国界性，还应特别注意遵守所在国家和地区所有有关的法律和法规。</p>
                <p>第五章 使用规则</p>
                <p>第十四条
                  您要注意保管好帐号及密码，不应将您的帐号、密码转让或出借给他人使用。如您发现帐号遭他人非法使用，应立即联系央视网客服中心。因黑客行为或您保管疏忽导致帐号、密码遭他人非法使用，央视网不承担任何责任。</p>
                <p>第十五条
                  您同意央视网有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在央视网的任何传播形式上投放广告），并且，您同意接受央视网通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。</p>
                <p>第十六条
                  对于您通过央视网网络服务（包括但不限于论坛、博客、微博、播客、跟帖评论）上传到央视网上可公开获取区域的任何内容，您同意央视网在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的下述权利：以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。</p>
                <p>第十七条 您在使用央视网服务过程中，必须遵循以下原则：</p>
                <p>(一) 遵守所有与网络服务有关的网络协议、规定和程序；</p>
                <p>(二) 不得为任何非法目的而使用网络服务系统；</p>
                <p>(三) 不得以任何形式使用央视网的网络服务侵犯央视网的商业利益，包括并不限于发布非经央视网许可的商业广告；</p>
                <p>(四) 不得利用央视网的网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
                <p>(五) 不得利用央视网的网络服务功能传播任何具有欺诈、胁迫、淫秽性的和损害他人人格尊严的信息资料；</p>
                <p>(六) 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；</p>
                <p>(七) 不得利用央视网的网络服务系统进行任何不利于央视网的行为。</p>
                <p>第十八条 您在使用央视网所提供的网络服务时，不得产生下列信息：</p>
                <p>(一) 违反宪法或法律法规规定的；</p>
                <p>(二) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                <p>(三) 损害国家荣誉和利益的，损害公共利益的；</p>
                <p>(四) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                <p>(五) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                <p>(六) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                <p>(七) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                <p>(八) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
                <p>(九) 含有法律、行政法规禁止的其他内容的。</p>
                <p>第十九条
                  您在设置帐号名称、头像和简介等注册信息时须遵守本协议第十八条的要求，不得出现违法和不良信息，并承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。</p>
                <p>第二十条
                  央视网有权对您使用其网络服务的情况进行审查和监督（包括但不限于对您存储在央视网的内容进行审核），如您在使用网络服务时违反本协议任何规定，央视网或其授权主体有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您已张贴的内容、暂停或终止您使用网络服务的权利等）以减轻因您的不当行为造成的影响。对于违反有关法律法规、侵犯他人隐私和名誉等内容，央视网有保存相关记录，并依法向有关部门提供的权利。</p>
                <p>第二十一条
                  央视网针对某些特定网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件等）作出的任何声明、通知、警示等内容视为本协议的一部分，您如使用该等网络服务，视为您同意该等声明、通知、警示的内容。</p>
                <p>第二十二条 您认为自己在央视网的权益受到侵害，有权根据央视网相关规定进行投诉、申诉。</p>
                <p>第二十三条 您有权对央视网互动平台管理提出批评、意见、建议，有权就互动平台管理工作提出咨询。</p>
                <p>第二十四条 您需遵守网络道德，注意网络礼仪，做到文明上网。</p>
                <p>第六章 服务变更、中断或终止</p>
                <p>第二十五条 鉴于网络服务的特殊性，您同意央视网有权随时变更、中断或终止部分或全部的网络服务。</p>
                <p>第二十六条
                  您理解：央视网需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，央视网无需为此承担任何责任，但应通过央视网尽可能事先进行通告。</p>
                <p>第二十七条 如发生下列任何一种情形，央视网有权随时中断或终止向您提供本协议项下的网络服务而无需对您或任何第三方承担任何责任：</p>
                <p>(一) 在任何情况下，央视网合理地认为您的行为可能违反中华人民共和国有关法律法规和规范性文件；</p>
                <p>(二) 您提供的个人资料不真实；</p>
                <p>(三) 您违反本协议中的部分条款。</p>
                <p>第二十八条您的帐号和密码遭到未授权的使用或发生其他任何安全问题，您可以立即通知央视网。在您每次连线结束时，应结束帐号使用，否则您可能得不到央视网的安全保护。
                <p>第七章 知识产权</p>
                <p>第二十九条
                  央视网提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。央视网不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向您或任何第三方负责。</p>
                <p>第三十条
                  央视网为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，您不得对该软件进行反向工程（reverse
                  engineer）、反向编译（decompile）或反汇编（disassemble）。</p>
                <p>第八章 隐私权保护</p>
                <p>第三十一条 保护用户隐私是央视网的一项基本政策，央视网保证不对外公开或向第三方提供您的注册资料及您在使用网络服务时存储在央视网的非公开内容，但下列情况除外：</p>
                <p>(一) 事先获得您的明确授权。</p>
                <p>(二) 依据有关法律规定，国家有关机关按照法律程序要求查询时，提供您的注册信息、您在央视网上发布的信息内容及其发布时间、互联网地址或者域名。</p>
                <p>(三) 为维护用户及社会公共利益的需要。</p>
                <p>(四) 为维护央视网的合法权益。</p>
                <p>第三十二条 央视网可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与央视网同等的保护用户隐私的责任，则央视网有权将您的注册资料等提供给该第三方。</p>
                <p>第三十三条 在不透露您的隐私资料前提下，央视网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
                <p>第九章 免责声明</p>
                <p>第三十四条 您明确同意您在使用央视网网络服务所存在的风险将完全由您自己承担；因您使用央视网网络服务而产生的一切后果也由您自己承担，央视网对您不承担任何责任。</p>
                <p>第三十五条 您对央视网提供的网络服务承担使用风险。央视网不保证服务一定会满足您的使用要求，也不保证服务不会中断，央视网对服务的及时性、安全性、准确性也不作担保。</p>
                <p>第三十六条 央视网不保证为向您提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由央视网实际控制的任何网页上的内容，央视网不承担任何责任。</p>
                <p>第三十七条 对于因不可抗力或央视网不能控制的原因造成的网络服务中断或其它缺陷，央视网不承担任何责任，但将尽力减少由此给您造成的损失和影响。</p>
                <p>第三十八条 您同意：对于央视网向您提供的下列产品或者服务的质量缺陷引发的任何损失，央视网无需承担任何责任：</p>
                <p>(一)央视网向您免费提供的各项网络服务；</p>
                <p>(二)央视网向您赠送的任何产品或者服务；</p>
                <p>(三)央视网向收费网络服务用户附赠的各种产品或者服务。</p>
                <p>第十章 违约赔偿</p>
                <p>第三十九条 如因央视网违反有关法律、法规或本协议项下的任何条款而给您造成损失，央视网同意承担由此造成的损害赔偿责任。</p>
                <p>第四十条 您同意保障和维护央视网及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给央视网或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。
                <p>第十一章 通知送达</p>
                <p>第四十一条 本协议项下央视网对您的所有通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
                <p>第四十二条 您对于央视网的通知应当通过央视网对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
                <p>第十二章 争议解决方式</p>
                <p>第四十三条 本协议及其修订本的有效性、履行和与本协议及其修订本效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律。</p>
                <p>第四十四条 因本协议所引起的您与央视网的任何纠纷或争议，首先应友好协商解决，协商不成的，您在此完全同意将纠纷或争议提交央视网所在地即北京市有管辖权的人民法院诉讼解决。</p>
                <p>第十三章 其他规定</p>
                <p>第四十五条 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
                <p>第四十六条 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
                <p>第四十七条 本协议将取代您先前与央视网签署的任何网络服务使用协议。本协议和央视网的其他服务条款构成完整的协议。</p>
                <p>第四十八条 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
                <p>第四十九条 本协议最终解释权归央视国际网络有限公司所有 。</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--邮箱激活弹窗-->
    <div class="active-modal large-info-modal modal fade" id="activeModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <p class="active-info">进入邮箱激活后才能完成注册!</p>
              <a href="javascript:void(0);" class="btn-at-sure" data-dismiss="modal">确&nbsp;&nbsp;认</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        MobilePhone: '',
        phone: ''
      }
    },
    methods: {
      //操作按钮事件
      fn() {
        if (window.history.length <= 1) {
          this.$router.push({name: 'home'});
        } else {
          this.$router.back(-1)
        }
      }
    },
    mounted: function () {
      var that = this
      $('.modal-backdrop').remove()
      // 大陆电话删除按钮
      $('.input-tel input').on('focus', function () {
        $(this).next('.btn-del').show();
      });
      $('.input-tel input').on('blur', function () {
        setTimeout(function () {
          $('.input-tel').find('.btn-del').hide()
        }, 100)
      });
      $('.input-tel').on('click', '.btn-del', function () {
        $(this).prev('input').val('');
        $(this).hide();
      });

      //操作DOM

      // checkbok 选中函数
      $('.check-box').on('click', function () {
        if ($(this).hasClass('oncheck')) {
          $(this).removeClass('oncheck');
        } else {
          $(this).addClass('oncheck');
        }
      });

      //tab 切换
      $('.lg-tab span').on('click', function () {
        var tabIndex = '';
        if (!$(this).hasClass('lg-active')) {
          $(this).addClass('lg-active').siblings('span').removeClass('lg-active');
          tabIndex = $(this).index();
          $('.lg-tabbox').eq(tabIndex).show().siblings('.lg-tabbox').hide();
        }
      });


      //$('#modalConfim').modal('show')

      $('.protocol-bg').on('click', function () {
        $('#modalConfim').modal('hide')
      })

      $('.terms').on('click', function () {
        $('#modalConfim').modal('show')

      })


      function getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      }

      var url_name = getQueryString('name');
      var iid = getQueryString('iid');

      $('#login').click(function () {
        if (iid) {
          window.location.href = 'accountlogin.html?name=' + url_name + '&iid=' + iid;
        } else {
          window.location.href = 'accountlogin.html?name=' + url_name;
        }
      })


      var that = this;
      getcode();

      function getcode() {
        $('.puts').click(function () {

          var num = 180;

          $('#yzm-img').hide();

          $('#phone-mess').hide();
          $('#yzm-mess').hide();

          // var phone=that.phone;
          var phone = $('#phone').val();
          var yzm_data = $('#yzm-data').val();

          if (!phone) {

            $('#phone-mess').show();
            $('#phone-mess').html('请输入手机号');
            return;
          }


          if (phone.match(/^1[3|5|7|8|9|][0-9]{9}$/) === null) {
            $('#phone-mess').show();
            $('#phone-mess').html('手机号格式不正确');
            return;
          }
          if (!yzm_data) {
            $('#yzm-img').show();
            $('#yzm-img').html('请输入图形验证码');
          }
          $.ajax({
            url: 'http://reg.cctv.com/regist/getVerifiCode.action',
            data: {
              method: 'getRequestVerifiCodeM',
              mobile: phone,
              verfiCodeType: 1,
              verificationCode: yzm_data,
              isCheckCode: 0
            },
            dataType: 'jsonp',
            success: function (mes) {
              if (mes.errtype == 'success') {
                $('.puts').unbind('click');
                var set = setInterval(function () {
                  num = num - 1;
                  $('.btn-yzm').html(num + '秒后获取');
                  if (num == 0) {
                    $('.btn-yzm').html('发送验证码');
                    getcode();
                    clearInterval(set);
                  }

                }, 1000)
              }
              if (mes.errtype == 'mobilecodeerror') {
                $('#yzm-img').show();
                $('#yzm-img').html(mes.errmsg);
              }
              if (mes.errtype == 'ipsendagain') {
                $('#yzm-img').show();
                $('#yzm-img').html('验证过于频繁,请稍后重试');
              }
              if (mes.errtype == 'mobileoften') {
                $('#yzm-img').show();
                $('#yzm-img').html('验证过于频繁,请稍后重试');
              }
              if (mes.errtype == 'registered') {
                $('#phone-mess').show();
                $('#phone-mess').html(mes.errmsg);
              }
              if (mes.errtype == 'sendagain') {
                $('#yzm-mess').show();
                $('#yzm-mess').html('验证过于频繁,请稍后重试');
              }
            }
          })
        })
      }

      $('.picyz').click(function () {
        $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
      })

      //手机注册
      $('#logined').click(function () {

        var url = encodeURI('http://ishow.xiyou.cctv.com/');
        $('#phone-mess').html('');
        var phone = $('#phone').val();
        var yzm = $('#yzm').val();
        var pass = $('#pass').val();
        var repass = $('#repass').val();
        var yzm_data = $('#yzm-data').val();
        $('#phone-mess').hide();
        $('#yzm-mess').hide();
        $('#pass-mess').hide();
        $('#repass-mess').hide();
        $('#xieyi-mess').hide();
        $('#yzm-img').hide();

        if (phone == '') {
          $('#phone-mess').show();
          $('#phone-mess').html('请输入手机号');
          return;
        }

        if (phone.match(/^1[3|5|7|8|9|][0-9]{9}$/) === null) {
          $('#phone-mess').show();
          $('#phone-mess').html('手机号格式不正确');
          return;
        }


        if (!yzm) {
          $('#yzm-mess').show();
          $('#yzm-mess').html('请输入验证码');
          return;
        }

        if (pass.length < 6 || pass.length > 20) {
          $('#pass-mess').show();
          $('#pass-mess').html('请输入6-20位的密码');
          return;
        }
        if (pass != repass) {
          $('#repass-mess').show();
          $('#repass-mess').html('两次输入密码不一致');
          return;
        }

        if (!yzm_data) {
          $('#yzm-img').show();
          $('#yzm-img').html('请输入图形验证码');
          return;
        }


        if ($('.group-terms').find('.oncheck').length == 0) {
          $('#xieyi-mess').show();
          $('#xieyi-mess').html('请同意使用协议');
          return;
        }
        $.ajax({
          url: 'https://reg.cctv.com/regist/mobileRegist.do',
          data: {
            method: 'saveMobileRegisterM',
            mobile: phone,
            verfiCodeType: 1,
            verfiCode: yzm,
            passWd: pass,
            addons: url
          },
          dataType: 'jsonp',
          success: function (mes) {
            if (mes.errtype == 'success') {
              that.$router.back(-1)
              /*  if(iid){
                    this.$router.push({name: 'login_SignIn', query: {id: iid}})

                }else{
                    this.$router.push({name: 'login_SignIn'})
                }*/
            }
            if (mes.errtype == 'registered') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'error') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'timeout') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
          }
        })
      })


      //邮箱注册
      $('#loginede').click(function () {


        var url = encodeURI('http://ishow.xiyou.cctv.com/');

        var email = $('#email').val();

        var pass = $('#pass_email').val();
        var repass = $('#repass_email').val();
        var yzm_data = $('#yzm_email').val();
        $('#email-mess').hide();

        $('#pass-mess').hide();
        $('#repass-mess').hide();
        $('#xieyi-mess-email').hide();
        $('#yzm-img-email').hide();

        if (email == '') {
          $('#email-mess').show();
          $('#email-mess').html('请输入邮箱地址');
          return;
        }

        if (email.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) === null) {
          $('#email-mess').show();
          $('#email-mess').html('邮箱格式不正确');
          return;
        }


        if (pass.length < 6 || pass.length > 20) {
          $('#pass-mess-email').show();
          $('#pass-mess-email').html('请输入6-20位的密码');
          return;
        } else {
          $('#pass-mess-email').hide();
        }
        if (pass != repass) {
          $('#repass-mess-email').show();
          $('#repass-mess-email').html('两次输入密码不一致');
          return;
        } else {
          $('#repass-mess-email').hide();
        }

        if (!yzm_data) {
          $('#yzm-img-email').show();
          $('#yzm-img-email').html('请输入图形验证码');
          return;
        }


        if ($('.group-terms-email').find('.oncheck').length == 0) {
          $('#xieyi-mess-email').show();
          $('#xieyi-mess-email').html('请同意使用协议');
          return;
        }
        $.ajax({
          url: 'https://reg.cctv.com/api/register.action',
          data: {
            mailAdd: email,
            passWd: pass,
            verificationCode: yzm_data,
            addons:  API.UrlName ,
            backurl: '/index.html'
          },
          dataType: 'jsonp',
          success: function (mes) {
            //console.log(mes)
            if (mes.msg == '成功') {
              /*  that.setCookie('userSeqId',mes.user_seq_id);*/
              that.$router.back(-1)
              //$('#activeModal').modal('show');
              $('#activeModal').modal('show');
            }
            if (mes.errtype == 'registered') {
              $('#yzm-mess-email').show();
              $('#yzm-mess-email').html(mes.errmsg);
            }
            if (mes.errtype != '0') {
              alert(mes.msg);
              $('.picyz').attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
              // $('#yzm-mess-email').show();
              // $('#yzm-mess-email').html(mes.msg);
            }
            if (mes.errtype == 'timeout') {
              $('#yzm-mess-email').show();
              $('#yzm-mess-email').html(mes.errmsg);
            }
          }
        })
      })


    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/register.vue